import { create } from 'zustand'
import axios from 'axios'

interface Shipping {
  selected?: any
  loading: boolean
  error?: any
  setLoading: (loading: boolean) => void
  setError: (error: any) => void
  setSelected: (selected: any) => void
  getOne: (id: number) => Promise<{ success: boolean; data: any }>
  create: (data: any) => Promise<{ success: boolean; data: any }>
  edit: (id: number, data: any) => Promise<{ success: boolean; data: any }>
  delete: (id: number) => Promise<{ success: boolean; data: any }>
  clearState: () => void
}

export const API_SLUG = 'issueRequest/changeShipping'

export const INITIAL_STATE = {
  id: 0,
  saleOrderId: 0,
  // 2023-08-29T19:27:00
  requestedAt: new Date(),
  // 2023-08-29T19:27:00
  requireDate: new Date(),
  requester: '',
  remark: '',
  quantity: '',
  pileCode: '',
  jobStatus: '',
}

export const useRequestShippingStore = create<Shipping>(set => ({
  selected: INITIAL_STATE,
  loading: false,
  error: undefined,
  setLoading: (loading: boolean) => {
    set({ loading })
  },
  setError: (error: any) => {
    set({ error })
  },
  setSelected: (selected: any) => {
    set({ selected })
  },
  getOne: async (id: number) => {
    set({ loading: true })
    return axios
      .get(`/${API_SLUG}/${id}`)
      .then(res => {
        set({ selected: res.data })
        set({ loading: false })
        return { success: true, data: res.data }
      })
      .catch(error => {
        set({ error })
        set({ loading: false })
        return { success: false, data: error }
      })
  },
  create: async (data: any) => {
    set({ loading: true })

    const formData = new FormData()
    Object.keys(data).forEach(key => {
      if (data[key] !== undefined) {
        formData.append(key, data[key])
      }
    })

    return axios
      .post(`/${API_SLUG}`, formData)
      .then(res => {
        set({ loading: false })
        return { success: true, data: res.data }
      })
      .catch(err => {
        set({ loading: false })
        set({ error: err?.response?.data?.message?.toString() })
        return { success: false, data: err?.response?.data?.message?.toString() }
      })
  },
  edit: async (id, data) => {
    set({ loading: true })

    const formData = new FormData()
    Object.keys(data).forEach(key => {
      if (data[key] !== undefined) {
        formData.append(key, data[key])
      }
    })

    return axios
      .patch(`/${API_SLUG}/${id}`, formData)
      .then(res => {
        set({ loading: false })
        return { success: true, data: res.data }
      })
      .catch(err => {
        set({ loading: false })
        set({ error: err?.response?.data?.message?.toString() })
        return { success: false, data: err?.response?.data?.message?.toString() }
      })
  },
  delete: async id => {
    set({ loading: true })
    return axios
      .delete(`/${API_SLUG}/${id}`)
      .then(res => {
        set({ loading: false })
        return { success: true, data: res.data }
      })
      .catch(err => {
        set({ loading: false })
        set({ error: err?.response?.data?.message?.toString() })
        return { success: false, data: err?.response?.data?.message?.toString() }
      })
  },
  clearState: () => {
    set({ selected: INITIAL_STATE, error: undefined, loading: false })
  },
}))
